import React from "react";
import lfr from "../../assets/lfr.jpeg";
import roddenber from "../../assets/roddenber.jpeg";
import {
  Container,
  LogoContainer,
  Image,
} from "../../styles/home/supporters.js";

const Supporters = () => {
  return (
    <>
      <Container>
        <h1>Supported by</h1>
        <LogoContainer>
          <Image src={lfr} />
          <Image src={roddenber} />
        </LogoContainer>
      </Container>
    </>
  );
};

export default Supporters;
